/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Running_Coaching_TermsInputs */

const en_service_type_running_coaching_terms = /** @type {(inputs: Service_Type_Running_Coaching_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`running, runner, running coach, marathon, half marathon, 10k`)
};

const pl_service_type_running_coaching_terms = /** @type {(inputs: Service_Type_Running_Coaching_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bieganie, biegacz, trener biegania, maraton, półmaraton, 10 km, technika biegu`)
};

/**
* | output |
* | --- |
* | "running, runner, running coach, marathon, half marathon, 10k" |
*
* @param {Service_Type_Running_Coaching_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_running_coaching_terms = /** @type {((inputs?: Service_Type_Running_Coaching_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Running_Coaching_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_running_coaching_terms(inputs)
	return en_service_type_running_coaching_terms(inputs)
});